import styled from 'styled-components';
import {
  Select,
} from 'components';

export const TextLine = styled.div`
  display: flex;
  align-items: center;
  color: #5d5d5d;
`;

export const CustomSelect = styled(Select)`
  margin-bottom: 11px;
  margin-right: 50px;
`;
